import React from "react"

function Header(){
    return(
        <header>
            <img src="./../public/logo192.png" alt=""/>
            <p>Meme Generator 2k21</p>
        </header>
    )
}

export default Header